<lib-modal-container
  class="bootstrap-wrapper"
  classModalTitle="bg-azul-sunedu"
  [modalTitle]="'Locales'"
  cancelText="Cerrar"
  [noActions]="true"
  (dismiss)="handleClose()">

  <div class="m-t-5 m-b-5">
    <google-map
      #gmap
      width="100%"
      height="650px"
      [options]="mapOptions"
      [center]="center"
      [zoom]="zoom">
      <map-marker
        *ngFor="let marker of locales"
        [position]="marker.position"
        [label]="marker.label"
        [title]="marker.title"
        [options]="marker.options">
      </map-marker>
      <map-info-window [options]="infoWindowOptions">{{ infoWindowMessage }}</map-info-window>
    </google-map>
  </div>

  <!-- <div
    class="m-t-5 m-b-5"
    fxlayout="column">

    <div
      class="m-t-5 m-b-5"
      fxLayoutAlign="center center">
      <button
        mat-flat-button
        type="button"
        class="bg-gray-sunedu  m-r-15 m-l-15 rounded-full btn-aceptar"
        (click)="dialogRef.close()">
        Cerrar
      </button>
    </div>
  </div> -->

</lib-modal-container>
